import { useCallback } from "react"
import { Address } from "viem"

import { ETHEREUM_CHAIN_ID } from "#/shared/constants"
import Portal from "#/shared/constants/artifacts/Portal"

import useWriteContractAndWaitForTransaction from "../contract"

import useBridgingHistory from "./useBridgingHistory"

export default function useBridgeDeposit(
  token: Address,
  amount: bigint,
  depositId?: number,
) {
  const { writeContractAsync, ...rest } =
    useWriteContractAndWaitForTransaction(ETHEREUM_CHAIN_ID)

  const { setLatestBridgeTransaction } = useBridgingHistory()

  const bridgeDeposit = useCallback(
    async (options?: {
      onError?: (error: unknown) => void
      onSuccess?: () => void
    }) => {
      if (!depositId) {
        throw new Error("Deposit id not defined")
      }

      const transactionHash = await writeContractAsync(
        {
          abi: Portal.abi,
          address: Portal.address,
          functionName: "bridgeDeposit",
          args: [token, depositId],
          chainId: ETHEREUM_CHAIN_ID,
        },
        options,
      )

      setLatestBridgeTransaction(amount, token, 18, transactionHash)
    },
    [writeContractAsync, setLatestBridgeTransaction, amount, token, depositId],
  )

  return {
    ...rest,
    bridgeDeposit,
  }
}
